import React from "react";

export default function CError() {
  return (
    <div style={{ maxWidth: 520, margin: "40px auto", padding: 16 }}>
      <h2>❌ Ödəniş uğursuz oldu</h2>
      <p>Ödəniş alınmadı və ya yarımçıq qaldı.</p>

      <a href="/couriersub/payments">Yenidən ödə</a>
      <span style={{ margin: "0 10px" }}>|</span>
      <a href="/couriersub/dashboard">Dashboard</a>
    </div>
  );
}

